import React, { useState } from 'react';
import { IconButton, Snackbar, Tooltip, Dialog, DialogTitle, DialogContent, DialogActions, Button } from '@mui/material';
import PeopleIcon from '@mui/icons-material/EmojiPeople';
import { callWaiter } from '../services/api';

interface WaiterCallButtonProps {
  /** Optionally pass tableId if known; otherwise component will try to use localStorage */
  tableId?: string;
  /** Whether the cart drawer is open - used for positioning animation */
  isCartOpen?: boolean;
}

const WaiterCallButton: React.FC<WaiterCallButtonProps> = ({ tableId, isCartOpen = false }) => {
  const [openSnack, setOpenSnack] = useState(false);
  const [snackMessage, setSnackMessage] = useState('');
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const resolvedTableId = tableId || localStorage.getItem('tableId') || '';

  const handleCallWaiter = async () => {
    if (!resolvedTableId) {
      setSnackMessage('No se pudo identificar la mesa');
      setOpenSnack(true);
      return;
    }
    setLoading(true);
    try {
      await callWaiter(resolvedTableId);
      setSnackMessage('Se ha solicitado al mesero');
    } catch (error) {
      console.error('Error calling waiter', error);
      setSnackMessage('Error al llamar al mesero');
    } finally {
      setLoading(false);
      setOpenSnack(true);
      setConfirmOpen(false);
    }
  };

  if (!resolvedTableId) {
    return null; // don't render if table id missing
  }

  return (
    <>
      <Tooltip title="Llamar al mesero" placement="bottom">
        <IconButton
          onClick={() => setConfirmOpen(true)}
          size="large"
          sx={{
            position: 'fixed',
            top: 16,
            right: isCartOpen ? 'auto' : 16,
            left: isCartOpen ? 16 : 'auto',
            zIndex: 1400,
            backgroundColor: '#ffffff',
            boxShadow: '0 2px 4px rgba(0,0,0,0.15)',
            '&:hover': { backgroundColor: '#f0f0f0' },
            width: 48,
            height: 48,
            transition: 'all 0.3s ease-in-out', // Smooth animation
          }}
        >
          <PeopleIcon fontSize="inherit" />
        </IconButton>
      </Tooltip>

      <Dialog open={confirmOpen} onClose={() => setConfirmOpen(false)}>
        <DialogTitle>¿Llamar al mesero?</DialogTitle>
        <DialogContent>
          ¿Deseas solicitar la atención del mesero en tu mesa?
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setConfirmOpen(false)} disabled={loading}>Cancelar</Button>
          <Button onClick={handleCallWaiter} variant="contained" disabled={loading}>
            Confirmar
          </Button>
        </DialogActions>
      </Dialog>

      <Snackbar
        open={openSnack}
        onClose={() => setOpenSnack(false)}
        autoHideDuration={4000}
        message={snackMessage}
      />
    </>
  );
};

export default WaiterCallButton;
